import { createElement } from '../utils/dom.js';
import { navigate } from '../router.js';
import { iconArrowLeft } from '../utils/icons.js';

/**
 * @param {HTMLElement|SVGElement} container
 * @param {string|HTMLElement|SVGElement} icon
 */
function appendActionIcon(container, icon) {
  if (typeof icon === 'string') {
    container.textContent = icon;
  } else if (icon instanceof HTMLElement || icon instanceof SVGElement) {
    container.appendChild(icon);
  }
}

/**
 * Rend la barre de navigation fixe en haut de page.
 * @param {{ title: string, backPath?: string, showLogo?: boolean, actions?: Array<{ icon: string|HTMLElement|SVGElement, label: string, onClick?: Function }> }} options
 * @returns {HTMLElement}
 */
export function renderHeader({ title, backPath, showLogo = false, actions = [] }) {
  const header = createElement('header', { className: 'header' });

  const backBtn = createElement('button', {
    className: 'header__back',
    attrs: { type: 'button', 'aria-label': 'Retour' },
    ...(backPath ? { children: [iconArrowLeft(20)] } : {}),
  });

  if (backPath) {
    backBtn.addEventListener('click', () => navigate(backPath));
  }

  let titleEl;
  if (showLogo) {
    titleEl = createElement('h1', {
      className: 'header__title header__title--logo',
    });
    const logoImg = createElement('img', {
      className: 'header__logo-img',
      attrs: { src: '/images/logo-text.png', alt: 'GroceWise', draggable: 'false' },
    });
    titleEl.appendChild(logoImg);
  } else {
    titleEl = createElement('h1', {
      className: 'header__title',
      text: title,
    });
  }

  const actionsContainer = createElement('div', {
    className: 'header__actions',
    attrs: { role: 'group' },
  });

  actionsContainer.style.display = 'flex';
  actionsContainer.style.alignItems = 'center';
  actionsContainer.style.gap = '2px';

  for (const action of actions) {
    const btn = createElement('button', {
      className: 'header__action',
      attrs: { type: 'button', 'aria-label': action.label },
      events: { click: () => action.onClick?.() },
    });
    appendActionIcon(btn, action.icon);
    actionsContainer.appendChild(btn);
  }

  header.append(backBtn, titleEl, actionsContainer);
  return header;
}
